import { createFileRoute } from '@tanstack/react-router';
import { TenantList } from '@/features/tenants/TenantList';

export const Route = createFileRoute('/tenants/')({
  component: TenantList,
});
